// extracted by mini-css-extract-plugin
export default {"menuItem":"DropdownUserItem_menuItem__TfLCa"};